import { formatRequest } from "../../utils/function";
import axiosInstance from "../axiosInstance";

export function createUserPoint(data) {
  return axiosInstance.post(`/user-points/create`, formatRequest(data));
}

export function getUserPointDetails(data) {
  return axiosInstance.post(`/user-points/details`, formatRequest(data));
}

export function  createOrUpdateUserPointProfileUpdate(data) {
  return axiosInstance.post(`/user-points/profile-userPoint-update`, formatRequest(data));
}

export function deleteUserPoint(data) {
  return axiosInstance.post(`/user-points/delete`, formatRequest(data));
}


